export const MAX_YEAR_DIFF = 21;

// card type mapped to the svg image name
export const cardIcons = {
  visa: 'visa',
  visaelectron: 'visa-electron',
  amex: 'amex',
  maestro: 'maestro',
  mastercard: 'mastercard',
  unionpay: 'unionpay',
  meeza: 'meeza',
  jcb: 'jcb',
  hipercard: 'hipercard',
  forbrugsforeningen: 'forbrugsforeningen',
  elo: 'elo',
  discover: 'discover',
  dinersclub: 'diners-club',
  dankort: 'dankort',
};

export const iconTypes = {
  cardNumber: 'card-icon',
  cardSecurityCode: 'cvv-icon',
};
